export const filterQuestions = (results: any, type: string) => {
  return results.filter(
    (result: any) => result?.library_question?.type === type
  );
};
